module.exports = __webpack_public_path__ + "static/media/QRcodeKingdom-playStore.4a74046c.svg";